import React from 'react';
import Modal from 'react-modal';
import { useSelector, useDispatch } from 'react-redux';

import * as actionTypes from '@redux/actionTypes';
import { paymentIntent } from "@services/api";
import { getModeByUrl } from '@util/config';
import { MinusIcon, PlusIcon } from '@util/svgicon';
import { safeLocalStorage } from '@utils/localstorage';

import Stripe from '../Stripe'

const PurchaseTimeCredit = () => {
    const dispatch = useDispatch();
    const token = safeLocalStorage.getItem('token')
    const coinNumberBalance = useSelector((state) => state.coinName.coinNumberBalance)
    const coinInputNumberDefault = useSelector((state) => state.coinName.coinInputNumberDefault)
    const strpiePayment = useSelector((state) => state.strpie.strpiePayment)
    const user = useSelector((state) => state.setUserDetails.user)

    const decrement = () => {
        const decrementNum = coinNumberBalance > coinInputNumberDefault ? coinNumberBalance - coinInputNumberDefault : coinInputNumberDefault
        dispatch({
            type: actionTypes.COIN_BALANCE_NUMBER,
            payload: decrementNum
        })
    }

    const increment = () => {
        const incrementNum = coinNumberBalance + coinInputNumberDefault
        dispatch({
            type: actionTypes.COIN_BALANCE_NUMBER,
            payload: incrementNum
        })
    }

    const handleSubmit = (e) => {
        dispatch({
            type: actionTypes.COIN_BALANCE_NUMBER,
            payload: e.target.value
        })
    }

    const handleSubmitChackOut = async (e) => {
        e.preventDefault();
        if (coinNumberBalance > 0) {
            try {
                const resp = await paymentIntent({
                    amount: coinNumberBalance,
                    currency: "USD",
                    wallet_address: token?.user?.wallet_address || user.wallet_address
                })
                if (resp?.data) {
                    dispatch({
                        type: actionTypes.STRPIE_PAYMNET,
                        payload: true
                    })
                    if (getModeByUrl() === 'testdrive') {
                        safeLocalStorage.setItem("botAccess", true)
                    }
                    const clientSecretkey = resp.data.payment_intent.client_secret
                    dispatch({
                        type: actionTypes.CLIENT_SECRET,
                        payload: clientSecretkey
                    })
                    dispatch({
                        type: actionTypes.PAYMENT_AMOUNT,
                        payload: resp?.data?.payment.amount
                    })
                }
            } catch (error) {
                console.log('error: ', error);
            }
        }
    }

    const payNowClose = () => {
        dispatch({
            type: actionTypes.STRPIE_PAYMNET,
            payload: false
        })
        safeLocalStorage.removeItem(`nftMinting`)
        safeLocalStorage.removeItem(`botAccess`)
    }

    const purchaseTcPopClose = () => {
        dispatch({
            type: actionTypes.BUY_TC,
            payload: false
        })
    }

    return (
        <div className="buy-time-modal" style={{ maxHeight: '535px' }}  >
            <div className="buy-time-section">
                <h1 className="title-small centered">Purchase Time Credits (TCs)</h1>
            </div>
            <div className="buy-time-section-tc m-0 p-0">
                <div className="quantity">
                    <h1 className="body-large black">Quantity ( TCs )</h1>
                    <div className="counter">
                        <div className="icon w-embed">
                            <button
                                type="button"
                                tabIndex={-1}
                                className="basis-1/3 focus:outline-none"
                                onClick={decrement}
                            >
                                <MinusIcon opacity={coinNumberBalance <= 10 ? 0.25 : 1} />
                            </button>
                        </div>
                        <div className="text-[#000] text-[20px] not-italic font-medium leading-[25px] tracking-[-0.38px]" onChange={handleSubmit}>{coinNumberBalance}</div>
                        <div className="icon w-embed">
                            <button
                                type="button"
                                tabIndex={-1}
                                className="basis-1/3 focus:outline-none"
                                onClick={increment}
                            >
                                <PlusIcon />
                            </button>
                        </div>
                    </div>
                </div>
                <div className="divider"></div>
                <div className="total-price">
                    <h1 className="body-large black">Total Price</h1>
                    <h1 className="body-large black">{coinNumberBalance} USD</h1>
                </div>
                <div className="divider"></div>
                <div className="total-price">
                    <h1 className="body-large black">Current TC Balance</h1>
                    <h1 className="body-large black">{user?.time_credit}</h1>
                </div>
            </div>
            <div className="buy-time-section-tc">
                <h1 className="body-large centered">Minimum purchase amount of $5 applies.</h1>
                <div className="divider"></div>
                <button className="button small w-button" onClick={handleSubmitChackOut}>Purchase</button>
                <button className="button small secondary w-button" onClick={purchaseTcPopClose}>Cancel</button>
            </div>
            <Modal
                isOpen={strpiePayment}
                ariaHideApp={false}
                className="mymodal"
                onRequestClose={payNowClose}
            >
                <Stripe payNowClose={payNowClose} />
            </Modal>
        </div>
    )
}

export default PurchaseTimeCredit;
